import chapter1 from './content/chapter1';
import chapter2 from './content/chapter2';
import chapter3 from './content/chapter3';
import chapter4 from './content/chapter4';
import chapter5 from './content/chapter5';
import chapter6 from './content/chapter6';
import chapter7 from './content/chapter7';
import chapter8 from './content/chapter8';
import chapter9 from './content/chapter9';

export const STORY_CONTENT = {
  chapters: {
    chapter1,
    chapter2,
    chapter3,
    chapter4,
    chapter5,
    chapter6,
    chapter7,
    chapter8,
    chapter9
  }
}
